
import './VerifyPass.css';
import toast from 'react-hot-toast';
import { useContext, useState } from 'react';
import { AuthContext } from '../../contexts/AuthProvider';
import LoaderSmall from '../Shared/LoderSmall/LoaderSmall';


const VerifyPassStudents = () => {
    const { sendPasswordResetEmaill } = useContext(AuthContext);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSendVerificationCode = async () => {
        try {
            setLoading(true);
            await sendPasswordResetEmaill(email);
            setLoading(false);
            toast.success('sent verification link to your email');
        } catch (error) {
            setLoading(false);
            console.error('Error sending verification code:', error);
            toast.error('Error sending verification code');  // Display error toast
        }
    };

    return (
        <div className=' max-w-[1320px] mx-auto'>
            <div className='w-full h-32 flex justify-center items-center bg-gray-50'>
                <h2 className='headingTxt'>Verify Your Password</h2>
            </div>
            <div className='mt-10 max-w-[620px] mx-auto'>
                <div className='border rounded-lg w-full h-80 border-gray-300 '>
                    <h1 className='px-10 py-5 textTwo'>Verify Password</h1>
                    <hr className='w-full border-1 border-gray-300'></hr>
                    <div className='px-10'>
                        <div className='translate-y-8 ml-5 bg-white w-32 flex justify-center items-center textMain'>
                            Enter Your Email
                        </div>
                        <input
                            type='email'
                            placeholder='type here'
                            value={email}
                            onChange={handleEmailChange}
                            className='input border-2 border-orange-500 w-full mt-5 h-[60px] input-warning'
                        />

                        <div className='mt-20'>
                            {loading ? (
                                <button className='w-56 h-10 flex justify-center 
                                items-center bg-orange-400 text-white rounded my-5'>
                                    <LoaderSmall />
                                </button>
                                // Show the loader when uploading
                            ) : (
                                <button onClick={handleSendVerificationCode} className='w-56
                                h-10 flex justify-center items-center bg-orange-400 text-white
                                 rounded my-5'>
                                    Send Verification Link
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyPassStudents;
